import React from 'react'
import { useTranslation } from 'react-i18next'
import BaseFreeformPicker from '../BaseFreeformPicker/BaseFreeformPicker'
import TextPicker from '../PageAssembler/InnerComponents/TextPicker/TextPicker'
import Caption from '../PageAssembler/InnerComponents/ImagePicker/Caption/Caption'
import { StoryProvider } from '../../providers/StoryProvider'
import useDynamicCharacterCounter from '../../hooks/useDynamicCharacterCounter/useDynamicCharacterCounter'
import { PAGE_WIDTH } from '../../constants/pageDimensions'

const FreeformTextPicker = ({
  picker,
  onPositionCommit,
  onRotateCommit,
  onDelete,
  onActivate,
  stickerBoundsRef,
  pageOffset,
  isPrintView = false,
  zindex,
}) => {
  const [t] = useTranslation()

  const { pickerData = {} } = picker
  const { memoryId, textType, caption = '', title = '', isPlaceholder } = pickerData

  const characterLimits = useDynamicCharacterCounter(picker.size?.width, picker.size?.height)

  // Check if this is a caption or title (not a story)
  const isCaption = textType === 'caption' || textType === 'title'
  const isHeading = textType === 'title'

  return (
    <BaseFreeformPicker
      picker={picker}
      onPositionCommit={onPositionCommit}
      onRotateCommit={onRotateCommit}
      onDelete={onDelete}
      onActivate={onActivate}
      stickerBoundsRef={stickerBoundsRef}
      pageOffset={pageOffset}
      isPrintView={isPrintView}
      zindex={zindex}
      resizeMode="freeform"
      maxSize={PAGE_WIDTH}
      minSize={100}
      defaultSize={350}
      contentDescription={t('FreeformTextPicker.defaultDescription', 'Draggable text picker')}
      deleteButtonTitle={t('FreeformTextPicker.deleteButton.title', 'Remove draggable')}
      testIdPrefix={`freeform-text-picker-${picker.id}`}
      shouldWaitForContentReady={false}
      renderContent={(contentProps) => {
        if (isCaption) {
          return (
            <Caption
              pageNumber={contentProps.pageNumber}
              caption={caption}
              title={title}
              isPrintView={contentProps.isPrintView}
              isHeading={isHeading}
              positionIndex={0}
              customLayoutElementId={contentProps.customLayoutElementId}
              onUpdateCustomLayoutElementData={contentProps.onUpdateCustomLayoutElementData}
              fillHeight
              alwaysShowBackground
              onCancelPlaceholder={onDelete}
            />
          )
        }

        return (
          <StoryProvider characterLimits={characterLimits}>
            <TextPicker
              pageNumber={contentProps.pageNumber}
              memoryId={memoryId}
              isPrintView={contentProps.isPrintView}
              positionIndex={0}
              customLayoutElementId={contentProps.customLayoutElementId}
              onUpdateCustomLayoutElementData={contentProps.onUpdateCustomLayoutElementData}
              dimensions={contentProps.dimensions}
              isPlaceholder={isPlaceholder}
              onCancelPlaceholder={onDelete}
            />
          </StoryProvider>
        )
      }}
    />
  )
}

export default FreeformTextPicker
